import React, { useState } from 'react';
import { X, Upload, CheckCircle2, XCircle, Info, Eye, ArrowLeft } from 'lucide-react';
import api from '../api/client';

const stagioneCorrente = () => {
  const oggi = new Date();
  const annoInizio = oggi.getMonth() >= 8 ? oggi.getFullYear() : oggi.getFullYear() - 1; // stagione sportiva 1/9–31/8
  return `${annoInizio}/${annoInizio + 1}`;
};

const ESEMPIO = 'email,nome,cognome,codice_fiscale,data_nascita,telefono,stagione,codice_asi_a,codice_asi_b,codice_fipav,scadenza\nmario.rossi@email.it,Mario,Rossi,RSSMRA80A01H501U,01/01/1980,3331234567,,,2473001,,';
const ESEMPIO_TESSERE = 'codice_fiscale,nome,cognome,stagione,codice_asi_a,codice_asi_b,codice_fipav,scadenza\nRSSMRA80A01H501U,Mario,Rossi,2026/2027,,2473001,,';

// soloTessere (23/10/2026, pagina Tesseramenti): niente account o schede nuove, anagrafica non toccata
export default function ImportaCsvUtentiModal({ onClose, onDone, soloTessere = false }) {
  const [csv, setCsv] = useState('');
  const [nomeFile, setNomeFile] = useState('');
  const [passwordIniziale, setPasswordIniziale] = useState('');
  const [permettiCreazione, setPermettiCreazione] = useState(!soloTessere);
  const [aggiornaAnagrafica, setAggiornaAnagrafica] = useState(false);
  const [forzaAsiA, setForzaAsiA] = useState(false);
  const [colonneIgnorate, setColonneIgnorate] = useState([]);
  const [stagioneDefault, setStagioneDefault] = useState(stagioneCorrente());
  const [loading, setLoading] = useState(false);
  const [risultati, setRisultati] = useState(null);
  const [anteprima, setAnteprima] = useState(false); // true = risultati di una simulazione, niente salvato
  const [error, setError] = useState('');

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setNomeFile(file.name);
    const reader = new FileReader();
    reader.onload = (ev) => setCsv(ev.target.result);
    reader.readAsText(file, 'UTF-8');
  };

  // anteprima obbligatoria (richiesta titolare 09/10): prima si simula, poi si conferma
  const handleSubmit = async (simula) => {
    setError(''); if (simula) setRisultati(null); // in conferma l'anteprima resta a video finché non arriva l'esito
    if (!csv.trim()) { setError('Carica o incolla un CSV'); return; }
    if (permettiCreazione && passwordIniziale && passwordIniziale.length < 8) { setError('La password iniziale deve essere di almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      const res = soloTessere
        ? await api.post('/tesseramenti/importa', { csv, stagioneDefault, forzaAsiA, anteprima: simula })
        : await api.post('/users/importa-csv', { csv, passwordIniziale: permettiCreazione ? passwordIniziale : undefined, stagioneDefault, permettiCreazione, aggiornaAnagrafica, forzaAsiA, anteprima: simula });
      setRisultati(res.data.risultati);
      setColonneIgnorate(res.data.colonne_ignorate || []);
      setAnteprima(simula);
      if (!simula) onDone && onDone();
    } catch (err) { setError(err.response?.data?.error || 'Errore'); }
    finally { setLoading(false); }
  };

  const creati = risultati?.filter(r => r.esito === 'creato').length || 0;
  const errori = risultati?.filter(r => r.esito === 'errore').length || 0;
  const aggiornati = risultati?.filter(r => r.esito === 'aggiornato').length || 0;
  const conAvvisi = risultati?.filter(r => r.avvisi?.length > 0).length || 0;
  const schede = risultati?.filter(r => r.esito === 'scheda').length || 0;

  return (
    <div style={s.overlay} onClick={e => e.stopPropagation()}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <span style={s.title}>{soloTessere ? 'IMPORTA TESSERE DA CSV' : 'IMPORTA UTENTI/TESSERAMENTI DA CSV'}</span>
          <button style={s.btnX} onClick={onClose}><X size={16}/></button>
        </div>

        <div style={s.body}>
          {!risultati && (
            <>
              {soloTessere ? (
              <div style={s.info}>
                <Info size={14} color="#F4600C" style={{ flexShrink:0, marginTop:'1px' }}/>
                <div>
                  <strong>Solo tessere:</strong> le persone devono essere già nel gestionale. Si riconoscono dal <strong>codice fiscale</strong> (anche schede senza account), poi dall'email; chi non si trova va in errore e <strong>non viene creato</strong>. Nome, cognome e dati dell'anagrafica non vengono toccati (si aggiunge solo il CF a chi non l'aveva).
                  Colonne: <code>codice_fiscale</code> (o <code>email</code>), <code>nome</code>, <code>cognome</code>, <code>stagione</code>, <code>codice_asi_a</code>, <code>codice_asi_b</code>, <code>codice_fipav</code>, facoltative <code>scadenza</code> o <code>scadenza_asi_a</code> / <code>scadenza_asi_b</code> / <code>scadenza_fipav</code>. Stessa persona e stessa stagione = il numero viene aggiornato. Per creare persone nuove: Impostazioni → Utenti → Importa da CSV.
                </div>
              </div>
              ) : (
              <div style={s.info}>
                <Info size={14} color="#F4600C" style={{ flexShrink:0, marginTop:'1px' }}/>
                <div>
                  Colonne CSV: <code>email,nome,cognome,codice_fiscale,data_nascita,telefono,stagione,codice_asi_a,codice_asi_b,codice_fipav</code> (ASI A = tornei amatoriali, ASI B = corsisti).
                  <strong>Scadenza facoltativa</strong>: senza, la tessera vale tutta la stagione (1/9–31/8); con la colonna <code>scadenza</code> vale per tutte le tessere della riga, con <code>scadenza_asi_a</code> / <code>scadenza_asi_b</code> / <code>scadenza_fipav</code> per la singola. Se reimporti senza scadenza, quella già salvata resta.
                  <strong>Email</strong> serve per creare l'account; <strong>senza email</strong> (ma con codice fiscale) la persona va solo in anagrafica con le sue tessere, e si collega quando si registrerà al portale. La persona si riconosce prima dal <strong>codice fiscale</strong>, poi dall'email: se c'è già un account si aggiungono solo le tessere (anagrafica e password non vengono toccate, salvo l'opzione qui sotto); se il CF è in anagrafica senza account, l'account nasce agganciato a quella scheda; altrimenti si crea l'utente.
                  Data di nascita in formato <code>YYYY-MM-DD</code> o <code>GG/MM/AAAA</code>.
                </div>
              </div>
              )}

              <div style={s.field}>
                <label style={s.label}>FILE CSV</label>
                <input type="file" accept=".csv,text/csv" onChange={handleFile} style={s.inputFile} />
                {nomeFile && <div style={s.nomeFile}>{nomeFile}</div>}
              </div>

              <div style={s.field}>
                <label style={s.label}>...OPPURE INCOLLA IL CONTENUTO CSV</label>
                <textarea style={s.textarea} rows={6} placeholder={soloTessere ? ESEMPIO_TESSERE : ESEMPIO} value={csv} onChange={e => { setCsv(e.target.value); setNomeFile(''); }} />
              </div>

              {!soloTessere && <>
              <label style={s.checkboxRow}>
                <input type="checkbox" checked={permettiCreazione} onChange={e => setPermettiCreazione(e.target.checked)} />
                Consenti la creazione di nuovi utenti (per chi non è ancora nel gestionale)
              </label>
              {!permettiCreazione && (
                <div style={s.nota}>Import di solo aggiornamento: nessuna password richiesta. Le righe con un'email non ancora esistente andranno in errore invece di creare un account.</div>
              )}

              <label style={s.checkboxRow}>
                <input type="checkbox" checked={aggiornaAnagrafica} onChange={e => setAggiornaAnagrafica(e.target.checked)} />
                Aggiorna l'anagrafica degli utenti già esistenti con i dati del file
              </label>
              {aggiornaAnagrafica && (
                <div style={{ ...s.nota, color:'#F59E0B' }}>Per le email già presenti sovrascrive nome, cognome, codice fiscale, data di nascita e telefono con quelli del file. Le colonne vuote non cancellano nulla. Controlla che nel file le colonne <code>nome</code> e <code>cognome</code> non siano invertite.</div>
              )}
              </>}

              <label style={s.checkboxRow}>
                <input type="checkbox" checked={forzaAsiA} onChange={e => setForzaAsiA(e.target.checked)} />
                Inserisci la ASI A anche a chi ha già la ASI B
              </label>
              {!forzaAsiA && (
                <div style={s.nota}>La ASI B copre anche la A: a chi ha già la B nella stessa stagione la A non viene inserita e la riga lo segnala.</div>
              )}

              <div style={{ display:'flex', gap:'12px' }}>
                {permettiCreazione && (
                  <div style={{ ...s.field, flex:1 }}>
                    <label style={s.label}>PASSWORD INIZIALE (per i nuovi account)</label>
                    <input style={s.input} type="text" value={passwordIniziale} onChange={e => setPasswordIniziale(e.target.value)} placeholder="Minimo 8 caratteri — serve solo se nel file ci sono email" />
                  </div>
                )}
                <div style={{ ...s.field, flex:1 }}>
                  <label style={s.label}>STAGIONE DI DEFAULT</label>
                  <input style={s.input} type="text" value={stagioneDefault} onChange={e => setStagioneDefault(e.target.value)} placeholder="2026/2027" />
                </div>
              </div>
              {permettiCreazione && (
                <div style={s.nota}>Usata solo se la riga del CSV non specifica una stagione propria nella colonna <code>stagione</code>. Ogni nuovo utente creato dovrà cambiare questa password al primo login.</div>
              )}

              {error && <div style={s.error}>{error}</div>}

              <button style={{ ...s.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={() => handleSubmit(true)} disabled={loading}>
                <Eye size={14}/> {loading ? 'VERIFICA IN CORSO...' : 'VERIFICA (ANTEPRIMA, NON SALVA NULLA)'}
              </button>
            </>
          )}

          {risultati && (
            <>
              {anteprima ? (
                <div style={s.bannerAnteprima}><Eye size={14} style={{ flexShrink:0 }}/> <div><strong>Anteprima: non è stato salvato niente.</strong> Ecco cosa succederebbe importando questo file adesso. Controlla soprattutto errori e avvisi in giallo, poi conferma o torna indietro a correggere.</div></div>
              ) : (
                <div style={{ ...s.bannerAnteprima, background:'#22C55E12', borderColor:'#22C55E40', color:'var(--text)' }}><CheckCircle2 size={14} color="#22C55E" style={{ flexShrink:0 }}/> <strong>Import eseguito.</strong></div>
              )}
              <div style={s.riepilogo}>
                <div><strong style={{ color:'#22C55E' }}>{creati}</strong> {anteprima ? 'da creare' : 'creati'}</div>
                {aggiornati > 0 && <div><strong style={{ color:'#F59E0B' }}>{aggiornati}</strong> {anteprima ? 'da aggiornare' : 'aggiornati'}</div>}
                {schede > 0 && <div><strong style={{ color:'#8B5CF6' }}>{schede}</strong> {anteprima ? 'solo in anagrafica (senza email)' : 'schede senza account'}</div>}
                <div><strong style={{ color:'#3B82F6' }}>{risultati.length - creati - aggiornati - errori - schede}</strong> già esistenti</div>
                <div><strong style={{ color:'#EF4444' }}>{errori}</strong> {anteprima ? 'righe da scartare' : 'errori'}</div>
                {conAvvisi > 0 && <div><strong style={{ color:'#F59E0B' }}>{conAvvisi}</strong> con avvisi</div>}
              </div>
              {colonneIgnorate.length > 0 && (
                <div style={{ ...s.nota, color:'#F59E0B' }}>Colonne del file non riconosciute, ignorate: <code>{colonneIgnorate.join(', ')}</code>. Se dentro c'erano dati da importare, rinomina l'intestazione e ricarica (chi è già stato creato risulterà "già esistente").</div>
              )}
              <div style={s.tabellaWrap}>
                {[...risultati].sort((a, b) => (b.esito === 'errore') - (a.esito === 'errore') || (b.avvisi?.length > 0) - (a.avvisi?.length > 0)).map(r => (
                  <div key={r.riga} style={s.rigaRisultato}>
                    {r.esito === 'errore' ? <XCircle size={14} color="#EF4444" style={{ flexShrink:0 }}/> : <CheckCircle2 size={14} color="#22C55E" style={{ flexShrink:0 }}/>}
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:'var(--font-size-xs)', fontWeight:'700' }}>Riga {r.riga} · {r.email || '(senza email)'}</div>
                      <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)' }}>{anteprima ? (DETTAGLIO_ANTEPRIMA[r.esito] || '') + r.dettaglio.replace(/^Utente creato$/, '') : r.dettaglio}{r.tessere?.length > 0 && ` · ${anteprima ? 'tessere da registrare: ' : ''}${r.tessere.join(', ')}`}</div>
                      {r.avvisi?.length > 0 && <div style={{ fontSize:'var(--font-size-xs)', color:'#F59E0B' }}>{r.avvisi.join(' · ')}</div>}
                    </div>
                  </div>
                ))}
              </div>
              {anteprima ? (
                <div style={{ display:'flex', gap:'10px' }}>
                  <button style={s.btnSecondario} onClick={() => { setRisultati(null); setAnteprima(false); }} disabled={loading}><ArrowLeft size={14}/> INDIETRO</button>
                  <button style={{ ...s.btnPrimary, flex:1, opacity: loading || errori === risultati.length ? 0.6 : 1 }} disabled={loading || errori === risultati.length}
                    onClick={() => handleSubmit(false)}>
                    <Upload size={14}/> {loading ? 'IMPORTAZIONE IN CORSO...' : errori === risultati.length ? 'NESSUNA RIGA VALIDA' : `CONFERMA E IMPORTA ${risultati.length - errori} RIGHE${errori ? ` (${errori} SCARTATE)` : ''}`}
                  </button>
                </div>
              ) : (
                <button style={s.btnPrimary} onClick={onClose}>CHIUDI</button>
              )}
              {error && <div style={s.error}>{error}</div>}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const DETTAGLIO_ANTEPRIMA = { creato: 'Verrà creato il nuovo utente', aggiornato: 'Da aggiornare — ', scheda: 'Senza email → ' };

const s = {
  bannerAnteprima: { display:'flex', gap:'10px', alignItems:'flex-start', background:'#3B82F612', border:'1px solid #3B82F640', borderRadius:'8px', padding:'10px 12px', fontSize:'var(--font-size-xs)', lineHeight:'1.6', color:'var(--text)' },
  btnSecondario: { display:'flex', alignItems:'center', justifyContent:'center', gap:'6px', background:'transparent', border:'1px solid var(--border2)', borderRadius:'8px', padding:'10px 14px', color:'var(--text-dim)', fontSize:'var(--font-size-xs)', fontWeight:'700', cursor:'pointer' },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal:      { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'12px', width:'100%', maxWidth:'560px', maxHeight:'88vh', display:'flex', flexDirection:'column' },
  header:     { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 20px', borderBottom:'1px solid var(--border)' },
  title:      { fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-sm)', fontWeight:'700', letterSpacing:'2px' },
  btnX:       { background:'transparent', border:'none', color:'var(--text-dim)', cursor:'pointer' },
  body:       { padding:'20px', display:'flex', flexDirection:'column', gap:'14px', overflowY:'auto' },
  info:       { display:'flex', gap:'10px', background:'#F4600C10', border:'1px solid #F4600C30', borderRadius:'8px', padding:'10px 12px', fontSize:'var(--font-size-xs)', color:'var(--text)', lineHeight:'1.6' },
  field:      { display:'flex', flexDirection:'column', gap:'6px' },
  checkboxRow:{ display:'flex', alignItems:'center', gap:'8px', fontSize:'var(--font-size-xs)', color:'var(--text-dim)', cursor:'pointer' },
  label:      { fontSize:'var(--font-size-xs)', letterSpacing:'1px', fontWeight:'700', color:'var(--text-dim)' },
  input:      { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'8px 12px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none' },
  inputFile:  { fontSize:'var(--font-size-xs)', color:'var(--text-dim)' },
  nomeFile:   { fontSize:'var(--font-size-xs)', color:'#22C55E' },
  textarea:   { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'8px 12px', color:'var(--text)', fontSize:'var(--font-size-xs)', outline:'none', fontFamily:'monospace', resize:'vertical' },
  nota:       { fontSize:'var(--font-size-xs)', color:'#555', marginTop:'-6px' },
  error:      { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btnPrimary: { display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', background:'#F4600C', color:'#fff', border:'none', borderRadius:'8px', padding:'11px', fontSize:'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', cursor:'pointer' },
  riepilogo:  { display:'flex', gap:'20px', fontSize:'var(--font-size-sm)', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'12px' },
  tabellaWrap:{ display:'flex', flexDirection:'column', gap:'6px', maxHeight:'320px', overflowY:'auto' },
  rigaRisultato:{ display:'flex', gap:'8px', alignItems:'flex-start', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'8px', padding:'8px 10px' },
};
